"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationMessages = exports.validationTests = void 0;
const execute_logic_1 = __importDefault(require("./execute-logic"));
const date_string_converter_1 = __importDefault(require("./date-string-converter"));
const friendly_date_string_1 = __importDefault(require("./friendly-date-string"));
const castNum = val => parseFloat(val);
const castDate = (ast, data) => {
    const val = ast instanceof Object && (ast.type === 'function' || ast.modelIds)
        ? (0, execute_logic_1.default)({ ast, data })
        : ast;
    if (val instanceof Date)
        return val;
    // if val is a date-like object and has a toDate fn,
    // (most notably, moment), execute the fn and return the date
    if (val instanceof Object) {
        return val.toDate ? val.toDate() : val;
    }
    const args = (0, date_string_converter_1.default)(val);
    return args && new Date(...args);
};
const fromASTOrNum = (astOrNumber, data) => {
    // xform-to-js v2.12.1 and earlier used to pass in a number
    if (typeof astOrNumber === 'number') {
        return astOrNumber;
    }
    const val = (0, execute_logic_1.default)({ ast: astOrNumber, data });
    return castNum(val);
};
const isSameDay = (d1, d2) => d1.getDate() === d2.getDate() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getFullYear() === d2.getFullYear();
const startDateValidation = (startDate, val) => isSameDay(startDate, val) || startDate < val;
const endDateValidation = (endDate, val) => isSameDay(endDate, val) || endDate > val;
const tOrF = {
    true: true,
    false: false,
};
const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
const phoneRegex = /^\d{10}$/;
// URL regex does not support FTP, IP addresses, port numbers
const urlRegex = /^(?:https?:\/\/)?(?:(?![-_])[-\w\u00a1-\uffff]{0,63}[^-_]\.)+[-\w\u00a1-\uffff]+(?:\/[^\s]*)?$/i;
exports.validationTests = {
    email: () => val => (val ? emailRegex.test(val) : true),
    phone: () => val => (val ? phoneRegex.test(val) : true),
    url: () => val => (val ? urlRegex.test(val) : true),
    maxlength: (astOrNumber, data) => val => val ? val.length <= fromASTOrNum(astOrNumber, data) : true,
    minlength: (astOrNumber, data) => val => val ? val.length >= fromASTOrNum(astOrNumber, data) : true,
    maxvalue: (astOrNumber, data) => val => val ? castNum(val) <= fromASTOrNum(astOrNumber, data) : true,
    minvalue: (astOrNumber, data) => val => val ? castNum(val) >= fromASTOrNum(astOrNumber, data) : true,
    range: ({ start, end }, data) => val => {
        if (!val) {
            return true;
        }
        const dateVal = castDate(val, data);
        return (!!dateVal &&
            startDateValidation(castDate(start, data), dateVal) &&
            endDateValidation(castDate(end, data), dateVal));
    },
    requiredForBind: enabled => val => (tOrF[enabled] ? val || val === 0 : true),
};
const pluralize = (word, len) => `${word}${len === 1 ? '' : 's'}`;
exports.validationMessages = {
    email: () => ['A valid email is required'],
    phone: () => ['A valid 10 digit phone number is required'],
    url: () => ['A valid URL is required'],
    maxlength: (astOrNumber, data) => {
        const len = fromASTOrNum(astOrNumber, data);
        return [`Maximum length is ${len} ${pluralize('character', len)}`, len];
    },
    minlength: (astOrNumber, data) => {
        const len = fromASTOrNum(astOrNumber, data);
        return [`Minimum length is ${len} ${pluralize('character', len)}`, len];
    },
    maxvalue: (astOrNumber, data) => {
        const num = fromASTOrNum(astOrNumber, data);
        return [`Maximum value is ${num}`, num];
    },
    minvalue: (astOrNumber, data) => {
        const num = fromASTOrNum(astOrNumber, data);
        return [`Minimum value is ${num}`, num];
    },
    range: ({ start, end }, data) => [
        `Minimum date is ${(0, friendly_date_string_1.default)(castDate(start, data))}. Maximum date is ${(0, friendly_date_string_1.default)(castDate(end, data))}`,
        // If we add the start and end dates here, they may break equality checks
        // instead, renderers can use the start and end date values passed as props
    ],
    requiredForBind: () => ['Required for bind'],
};
//# sourceMappingURL=validators.js.map